/* N1 · Comparador: público y tallas dentro del resumen + estilo del filtro Adulto/Niños.
   Este archivo se carga después de n1-compare-sum3.js y añade el párrafo de tallas.
   07/10/2026 (multidioma fase 2, lote 3b): frases desde window.N1T (claves n1.cmp.tl_*), con el español como respaldo.
   11/10/2026 (paquete H2, AY-14): frases sin términos anatómicos y válidas para 2 o 3 guantes (claves n1.cmp.v2_tl_*); la diferencia de
   látex entre infantil y adulto se calcula con los milímetros de la ficha (solo se dice si existe). Niño = dato "kid" de
   snippets/n1-compare-items (etiqueta Niños sin Adulto); el título solo se mira si falta el dato. Las tallas son las de stock en Europa. */
(function(){
if(window.N1Tallas)return;window.N1Tallas=1;
var T=function(k,d){var v=window.N1T&&window.N1T[k];return (typeof v==='string'&&v&&!/translation missing/i.test(v))?v:d},F=function(s,o){return String(s).replace(/\{(\w+)\}/g,function(m,k){return o&&o[k]!=null?o[k]:m})};
function nums(t){return (t||'').split(/[^0-9]+/).filter(Boolean).map(Number)}
function kid(x){return typeof x.kid==='boolean'?x.kid:/kids|niñ|crian/i.test(x.t)}
function mm(t){var m=/([0-9](?:[.,][0-9])?)\s*mm/.exec(t||'');return m?parseFloat(m[1].replace(',','.')):0}
var DEC=/^en/i.test((window.Shopify&&Shopify.locale)||document.documentElement.lang||'')?'.':',';
/* 11/10/2026: tallas seguidas como rango (6–11); si falta alguna talla en stock, la lista (3, 6, 7) */
function rango(a){if(!a.length)return '';a=a.slice().sort(function(x,y){return x-y});var mn=a[0],mx=a[a.length-1];if(mx-mn===a.length-1)return a.length>1?mn+'–'+mx:String(mn);return a.join(', ')}
function build(items){
  var withT=items.filter(function(x){return nums(x.specs.tallas).length});
  if(withT.length<2)return '';
  var kids=withT.filter(kid),ad=withT.filter(function(x){return !kid(x)});
  var txt='';
  if(kids.length&&ad.length){
    var k=kids[0],a=ad[0];
    var inter=nums(k.specs.tallas).filter(function(n){return nums(a.specs.tallas).indexOf(n)>-1});
    txt=F(T('n1.cmp.tl_mix_html','<b>{a}</b> es un guante de adulto (tallas {ra}) y <b>{k}</b> es infantil (tallas {rk}). '),{a:a.t,ra:rango(nums(a.specs.tallas)),k:k.t,rk:rango(nums(k.specs.tallas))});
    if(inter.length){
      txt+=F(T('n1.cmp.v2_tl_inter','Coinciden en la talla {t}: si es la tuya, te sirven los dos.'),{t:inter.join(T('n1.cmp.tl_join',' y la '))});
      var ma=mm(a.specs.palma),mk=mm(k.specs.palma);
      if(ma&&mk&&ma>mk)txt+=' '+F(T('n1.cmp.v2_tl_more','El de adulto lleva el látex exterior más grueso ({a} mm frente a {k} mm).'),{a:String(ma).replace('.',DEC),k:String(mk).replace('.',DEC)});
    }else{
      txt+=T('n1.cmp.v2_tl_none','No comparten ninguna talla: elige el que tenga la tuya.');
    }
  }else{
    var todas=withT.map(function(x){return rango(nums(x.specs.tallas))});
    var igual=todas.every(function(t){return t===todas[0]});
    var kidAll=kids.length===withT.length;
    txt=igual?F(kidAll?T('n1.cmp.v2_tl_kids','Son guantes infantiles y comparten tallas ({r}).'):T('n1.cmp.v2_tl_same','Son guantes de adulto y comparten tallas ({r}).'),{r:todas[0]}):F(T('n1.cmp.tl_list','Tallas → {list}.'),{list:withT.map(function(x,i){return '<b>'+x.t+'</b>: '+todas[i]}).join(' · ')});
  }
  return txt;
}
function dataFor(root){
  var s=root.closest('#n1k-cpop')?document.getElementById('cmpdpop'):[].slice.call(document.querySelectorAll('script[type="application/json"]')).filter(function(x){return /^cmpd/.test(x.id)})[0];
  if(!s)return null;try{return JSON.parse(s.textContent)}catch(e){return null}
}
function run(){
  [].slice.call(document.querySelectorAll('.n1-compare')).forEach(function(root){
    var sum=root.querySelector('[data-sum] .sum');if(!sum)return;
    if(sum.dataset.tallas)return;
    var on=[].slice.call(root.querySelectorAll('.chip.on')).map(function(c){return c.getAttribute('data-h')});
    if(on.length<2)return;
    var D=dataFor(root);if(!D)return;
    var items=on.map(function(h){for(var i=0;i<D.items.length;i++)if(D.items[i].h===h)return D.items[i];return null}).filter(Boolean);
    var t=build(items);
    if(t){var p=document.createElement('p');p.innerHTML=t;sum.appendChild(p)}
    sum.dataset.tallas=1;
  });
}
document.addEventListener('click',function(e){if(e.target.closest('.n1-compare .chip'))setTimeout(run,220)},true);
document.addEventListener('n1cmp:render',function(){setTimeout(run,140)});
addEventListener('load',function(){setTimeout(run,700)});
setTimeout(run,1200);setTimeout(run,2200);
})();
